import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=5dff5b96&scoped=true"
import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=5dff5b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff5b96",
  null
  
)

export default component.exports